// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"2a206593","366":"5f1409c6","503":"5dc547f1","846":"da8baecb"}[chunkId] + ".chunk.js";
};